namespace RioERP.Inventory {
    export interface PendriveInwardForm {
        PenDriveTypeId: Serenity.LookupEditor;
        InwardDate: Serenity.DateEditor;
        Qty: Serenity.IntegerEditor;
        Rate: Serenity.DecimalEditor;
        VendorId: Serenity.IntegerEditor;
        BillDocument: Serenity.StringEditor;
        Notes: Serenity.StringEditor;
    }

    export class PendriveInwardForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.PendriveInward';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PendriveInwardForm.init)  {
                PendriveInwardForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.StringEditor;

                Q.initFormType(PendriveInwardForm, [
                    'PenDriveTypeId', w0,
                    'InwardDate', w1,
                    'Qty', w2,
                    'Rate', w3,
                    'VendorId', w2,
                    'BillDocument', w4,
                    'Notes', w4
                ]);
            }
        }
    }
}
